var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTripleLineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "33px",
    viewBox: "0 0 36 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3D4D60B6-78B8-47C4-A835-C4BA46A1B356") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.4.0-Mojo-SignUp",
    transform: "translate(-1081.000000, -395.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(990.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signUp-tripleLine-icon",
    transform: "translate(89.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4271268,12.4 C8.03259708,12.4 2.99970693,15.5074572 2.98074215,15.519347 L1.00079687,16.8352148 C-0.587526878,17.8610224 -0.958870488,19.2366666 -0.950003854,20.3509193 C-0.939887664,21.2327317 -0.461296474,22.4899279 0.0385406734,23.7048913 C0.316488209,24.396403 0.825443838,24.8499213 1.38727677,25.0552523 C1.99063229,25.2757585 2.67916628,25.2268703 3.30553024,24.8187708 L7.40363269,22.1620963 C7.88552224,21.8494807 8.27690877,21.410225 8.52074225,20.9559927 C8.80727064,20.4222249 8.92670563,19.8691724 8.70064197,19.1079616 C8.66094114,18.9725021 8.63323818,18.8595487 8.6112459,18.5536948 C9.27324693,18.0093608 11.157682,16.7507328 14.4275241,16.7494336 C17.8237161,16.7507827 19.724438,18.108067 20.3141011,18.6130255 C20.2483487,18.7944818 20.190617,18.9869575 20.0999406,19.2949398 C19.9588597,19.7689898 20.0208487,20.371568 20.3350619,20.9569093 C20.5788438,21.4110456 20.9702345,21.8501466 21.4530073,22.1625464 L25.5523408,24.8200225 C26.1746543,25.2265165 26.8628957,25.2759112 27.4664024,25.0557745 C27.9746179,24.8703965 28.4870378,24.5193757 28.9291265,23.4304204 C29.3010429,22.5286953 29.7939675,21.24787 29.8042233,20.3544404 C29.8131252,19.2389976 29.4416864,17.8606548 27.8528007,16.8347912 L25.781175,15.4624396 C25.1978226,15.1179614 20.4083736,12.4 14.4271268,12.4 Z",
    id: "Fill-1",
    stroke: "#0964DE",
    transform: "translate(14.427127, 18.791558) rotate(-132.000000) translate(-14.427127, -18.791558) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.9011922,
    y1: 10.5101247,
    x2: 33.5572478,
    y2: 2.151069,
    id: "Line-5",
    stroke: "#45B209",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#45B209",
    strokeLinecap: "round",
    points: "28.6937286 2 33.5551889 2.08485711 33.4703318 6.94631748"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.8317756,
    y1: 10.6813445,
    x2: 24.4878312,
    y2: 2.32228874,
    id: "Line-5",
    stroke: "#45B209",
    strokeLinecap: "round",
    transform: "translate(20.159803, 6.501817) rotate(-45.000000) translate(-20.159803, -6.501817) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#45B209",
    strokeLinecap: "round",
    transform: "translate(20.186532, 3.848273) rotate(-45.000000) translate(-20.186532, -3.848273) ",
    points: "17.7558023 1.37511462 22.6172627 1.45997173 22.5324056 6.32143211"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.0713478,
    y1: 20.438139,
    x2: 34.7274034,
    y2: 12.0790833,
    id: "Line-5",
    stroke: "#45B209",
    strokeLinecap: "round",
    transform: "translate(30.399376, 16.258611) rotate(45.000000) translate(-30.399376, -16.258611) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#45B209",
    strokeLinecap: "round",
    transform: "translate(33.052919, 16.285340) rotate(45.000000) translate(-33.052919, -16.285340) ",
    points: "30.6221887 13.8121815 35.4836491 13.8970386 35.398792 18.758499"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleLineIcon);
export default __webpack_public_path__ + "static/media/triple-line-icon.29b71d1cc0ea2721c8c5a08114c0c3c2.svg";
export { ForwardRef as ReactComponent };